export const getHasMinimumEmployees = (employees, allowSingleOwner) => {
  const employeeCount = employees.length;
  const ownerOnlyGroup = isOwnerOnlyGroup(employees);
  if (employeeCount >= 2) {
    return true;
  }
  if (ownerOnlyGroup && allowSingleOwner) {
    return true;
  }
  return false;
};

export const isOwnerOnlyGroup = (employees) => employees.length == 1 && employees[0].employee_type === "owner";

// Partners choose which employees are eligible, this function filters any employee that's not eligible
export const mergeEmployeesWithEligibityForm = (employees, employeeEligiblity) =>
  employeeEligiblity
    ? employees
        .map((ee) => {
          if (employeeEligiblity[ee.hash_id]) {
            return {
              ...ee,
              is_eligible: employeeEligiblity[ee.hash_id].is_eligible,
            };
          }
          return ee;
        })
        .filter((ee) => ee.is_eligible === "true")
    : [];
